export interface IDevices {
  audioinput: string | null;
  audiooutput: string | null;
  videoinput: string | null;
}

function isDefaultDevice(device?: MediaDeviceInfo | null): boolean {
  return device?.deviceId === 'default';
}

function sortDefaultDevices(devices: MediaDeviceInfo[]): MediaDeviceInfo[] {
  return devices.sort((a, b) => {
    if (isDefaultDevice(a) && !isDefaultDevice(b)) {
      return -1;
    }
    if (!isDefaultDevice(a) && isDefaultDevice(b)) {
      return 1;
    }
    return 0;
  });
}

export const getDefaultDevices = async (): Promise<IDevices> => {
  const defaultDevices: {
    audioinput: MediaDeviceInfo | null;
    audiooutput: MediaDeviceInfo | null;
    videoinput: MediaDeviceInfo | null;
  } = { audioinput: null, audiooutput: null, videoinput: null };

  return navigator.mediaDevices
    .enumerateDevices()
    .then(sortDefaultDevices)
    .then((devices) => {
      devices.forEach((device) => {
        if (!defaultDevices[device.kind]) {
          defaultDevices[device.kind] = device;
          return;
        }

        if (
          isDefaultDevice(defaultDevices[device.kind]) &&
          device.groupId === defaultDevices[device.kind]?.groupId
        ) {
          defaultDevices[device.kind] = device;
          return;
        }
      });

      const devicesIds = {
        audioinput: defaultDevices.audioinput?.deviceId || null,
        audiooutput: defaultDevices.audiooutput?.deviceId || null,
        videoinput: defaultDevices.videoinput?.deviceId || null,
      };

      return devicesIds;
    })
    .catch(() => {
      return {
        audioinput: null,
        audiooutput: null,
        videoinput: null,
      };
    });
};
